// loadingIndicator.js

/**
 * Gets the loading indicator element (creates it if necessary).
 *
 * @param {HTMLElement|null} parentElement
 * @returns {HTMLElement|null}
 */
export const getLoadingElement = (parentElement) => {
  if (parentElement === null) {
    return null;
  }

  let loadingElement = /** @type {HTMLElement|null} */ (parentElement.querySelector('[data-loading]'));
  if (loadingElement === null) {
    loadingElement = document.createElement('div');
    loadingElement.setAttribute('data-loading', '');
    loadingElement.innerHTML = '<span class="icon is-small is-left"><i class="fas fa-spinner fa-spin"></i></span>';
    parentElement.prepend(loadingElement);
  }

  loadingElement.classList.add('show');

  return loadingElement;
};
